// extracted by mini-css-extract-plugin
export default {"submit":"passwordRecovery_submit__zlS3Y","rememberedPassword":"passwordRecovery_rememberedPassword__ZH2JQ","link":"passwordRecovery_link__xHMRr"};